import React from "react"
import { MainCP } from "../../Components/conocimientos-rostros-publicitarios-2024/MainCP"

const ViewConocimientosRostrosPublicitarios2024: React.FC = () => <MainCP/>

export default ViewConocimientosRostrosPublicitarios2024